import { render, staticRenderFns } from "./LiveTimestamp.vue?vue&type=template&id=1534c038&scoped=true&"
import script from "./LiveTimestamp.vue?vue&type=script&lang=js&"
export * from "./LiveTimestamp.vue?vue&type=script&lang=js&"
import style0 from "./LiveTimestamp.vue?vue&type=style&index=0&id=1534c038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534c038",
  null
  
)

export default component.exports